import React from 'react'
import { useSelector } from 'react-redux'
import styles from './styles.module.css'
import { COUNTRY_INFO } from '../../constans/countries/countries'
import { WishListContainer } from './WishListContainer/WishListContainer'
import { useState } from 'react'

export const WishListComponent = ({ wishlistCountries, isShared = false }) => {
    const wishListState = useSelector((state) => state.wishList.wishlist);
    const wishListAllowed = wishlistCountries || wishListState;
    const sortedWishList = [...wishListAllowed].reverse();
    const [showAll, setShowAll] = useState(false);

    const countriesToShow = showAll ?
                            sortedWishList :
                            sortedWishList.slice(0,7)

    return (
      <div className={styles.root}>
        <div className={styles.content_wrapper}>
          {countriesToShow.map(e => 
            <WishListContainer
              key={e}
              country={COUNTRY_INFO[e]}
              isShared={isShared} d
            />
          )}
        </div>
        {wishListState.length > 7 && (
          <div className={styles.others_button_container}>
          {!showAll ? 
            <button
              className={styles.others_button}
              onClick={() => setShowAll(!showAll)}>
              See others
              <div className={styles.others_arrow_icon}>→</div>
            </button>
            :
            <button
              className={styles.others_button}
              onClick={() => setShowAll(!showAll)}>
              <div className={styles.others_arrow_icon}>←</div>
              Show less
            </button>
          }
          </div>
      )}
      </div>
    )
}